// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getValidDomainUrl } from "../../../actions/AuthActions/authMethods";
// import { buttonClickEvent } from "../../../gtm/gtmutils";
// import GTM_EVENTS from "../../../gtm/gtmevents";

// Components Import
import TitleBar from "../../TitleBar";

// Declarations
const NAV_OPTIONS = [
  {
    alias: "organization",
    label: "My Templates",
    link: "/templates",
    icon: "files-medical",
    // gtmAction: buttonClickEvent,
  },
  {
    alias: "global",
    label: "Templates Library",
    url: `${getValidDomainUrl()}/templates`,
    icon: "globe",
    // gtmAction: buttonClickEvent,
  },
];

export default function TemplateLeftSection(props) {
  return (
    <div className="templateleftsection-wrapper">
      {/** TITLE SECTION */}
      <section className="templatesection-title-weapper">
        <TitleBar
          iconName="files-medical"
          title="Templates"
          subTitle="All your templates"
        />
      </section>
      <section className="templateleftsection-nav-options">
        {NAV_OPTIONS.map(option => (
          <div
            key={option.alias}
            className={`templateleftsection-title ${
              props.currentView === option.alias ? "is-active" : ""
            }`}>
            <span>
              {option.link && <Link to={option.link}>{option.label}</Link>}
              {option.url && (
                <a
                  href={option.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  // onClick={option.gtmAction(GTM_EVENTS.TEMPLATE_LIBRARY_CLICK)}
                  data-test="templateleftsection-link">
                  {option.label}
                  <i className="templateleftsection-title-linkicon">
                    <FontAwesomeIcon icon={["far", "external-link-alt"]} />
                  </i>
                </a>
              )}
            </span>
          </div>
        ))}
      </section>
    </div>
  );
}

TemplateLeftSection.propTypes = {
  currentView: PropTypes.string.isRequired,
};
